import {eopCustomEvent} from "../../common/utils/events";

export const MACHERBUS_PROJECT_VOTE_EVENT = "eop-macherbus-project-vote";

export type MacherbusProjectVoteEvent = CustomEvent<MacherbusProjectVoteEventData>;

export type MacherbusProjectVoteEventData = {
    projectId: string
    voted: boolean
};

export function macherbusProjectVoteEvent(projectId: string, value: boolean): MacherbusProjectVoteEvent {
    return eopCustomEvent(MACHERBUS_PROJECT_VOTE_EVENT, {projectId: projectId, voted: value});
}